/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'maintenance-windows',
  title: 'Announce maintenance',
  category: 'Status pages',
  summary:
    'Schedule a maintenance window for a component so visitors are told in advance and the downtime does not count against your uptime.',
  keywords: ['maintenance', 'maintenance window', 'planned downtime', 'announcement', 'uptime', 'status page'],
};

export const loadComponent = () => import('./maintenance-windows.component').then((m) => m.MaintenanceWindowsArticleComponent);
